import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { TimeZoneEnum } from '../enums/verticaltype.enum';

@Injectable({
  providedIn: 'root',
})
export class TimezoneUtilService {
  private readonly timezoneMap: Record<TimeZoneEnum, string> = {
    [TimeZoneEnum.EST]: 'America/New_York',
    [TimeZoneEnum.CST]: 'America/Chicago',
    [TimeZoneEnum.MST]: 'America/Denver',
    [TimeZoneEnum.PST]: 'America/Los_Angeles',
  };

  private getZoneNameFromEnum(tzEnum?: TimeZoneEnum): string {
    return tzEnum !== undefined && this.timezoneMap[tzEnum]
      ? this.timezoneMap[tzEnum]
      : DateTime.local().zoneName; // fallback
  }

  // This method is now a class method (remove 'export function')
  convertFromSelectedTimezoneToEST(date: Date, fromTimeZone: TimeZoneEnum): string {
  // Extract date/time parts from the JS Date object
  const interpretedAsSelectedTz = DateTime.fromObject(
    {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: date.getSeconds()
    },
    { zone: this.getZoneNameFromEnum(fromTimeZone) } // ⬅️ Treat this as input time zone
  );

  const estLocal = interpretedAsSelectedTz.setZone('America/New_York');

  return estLocal.toFormat("yyyy-MM-dd'T'HH:mm:ss"); 
}

public convertFromESTToSelectedTimezone(
  estTime: string, // in ISO format like "2025-07-24T14:22:00"
  selectedTzEnum?: TimeZoneEnum
): string {
  return DateTime.fromISO(estTime, { zone: 'America/New_York' })
    .setZone(this.getZoneNameFromEnum(selectedTzEnum))
    .toFormat("yyyy-MM-dd'T'HH:mm:ss");
}

  public convertFromUTCToSelectedTimezone(
    utcTime: string,
    selectedTzEnum?: TimeZoneEnum
  ): string {
   return DateTime.fromISO(utcTime, { zone: 'utc' })
    .setZone(this.getZoneNameFromEnum(selectedTzEnum))
    .toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }

  public getLocalTimezone(): string {
    return DateTime.local().zoneName;
  }
}
